import { Controller } from "stimulus"
import Chart from "chart.js"

// Single bar chart with two Y axes: quantity sold (left) and revenue $ (right).
// Chart.js v2.9.4 syntax (yAxes/xAxes arrays, yAxisID, scaleLabel).
export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    labels: Array,
    quantities: Array,
    revenues: Array
  }

  connect() {
    this.renderChart()
  }

  renderChart() {
    const ctx = this.canvasTarget.getContext("2d")

    new Chart(ctx, {
      type: "bar",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            label: "Productos vendidos",
            data: this.quantitiesValue,
            backgroundColor: "rgba(0, 123, 255, 0.65)",
            borderColor: "#007bff",
            borderWidth: 1,
            yAxisID: "yQty"
          },
          {
            label: "Ingresos ($)",
            data: this.revenuesValue,
            backgroundColor: "rgba(40, 167, 69, 0.65)",
            borderColor: "#28a745",
            borderWidth: 1,
            yAxisID: "yRev"
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: 800 },
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            label: function(tooltipItem, data) {
              const dataset = data.datasets[tooltipItem.datasetIndex]
              const label = dataset.label || ""
              const value = tooltipItem.yLabel
              if (value == null) return null
              if (dataset.yAxisID === "yRev") {
                return label + ": $" + value.toLocaleString("es-AR")
              }
              return label + ": " + value.toLocaleString("es-AR")
            }
          }
        },
        legend: {
          labels: { usePointStyle: true, padding: 20 }
        },
        scales: {
          yAxes: [
            {
              id: "yQty",
              type: "linear",
              position: "left",
              ticks: { beginAtZero: true, fontColor: "#007bff" },
              scaleLabel: {
                display: true,
                labelString: "Cantidad",
                fontColor: "#007bff",
                fontStyle: "bold"
              },
              gridLines: { color: "rgba(0, 123, 255, 0.08)" }
            },
            {
              id: "yRev",
              type: "linear",
              position: "right",
              ticks: {
                beginAtZero: true,
                fontColor: "#28a745",
                callback: function(value) { return "$" + value.toLocaleString("es-AR") }
              },
              scaleLabel: {
                display: true,
                labelString: "Ingresos ($)",
                fontColor: "#28a745",
                fontStyle: "bold"
              },
              gridLines: { drawOnChartArea: false }
            }
          ],
          xAxes: [{ gridLines: { color: "rgba(0, 0, 0, 0.05)" } }]
        }
      }
    })
  }
}
